import app from 'flarum/forum/app';
import Icon from 'flarum/common/components/Icon';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import { field, section, tip } from './Field';
import { teamPayload } from './TeamSection';
const t = (key, params) => app.translator.trans('ppk2-profile.forum.club_team.banner.' + key, params);

/** Banner part of the team state (ts = teamState()). */
export function bannerState(ts) {
  const init = ts.initial;
  ts.bannerUrl = init ? init.bannerUrl || null : null;
  ts.showBanner = Stream(init ? init.showBanner !== false : true);
  ts.uploading = false;
}

/** The section is shown only for the SAVED main team (hidden while choosing / leaving). */
export function bannerVisible(ts) {
  return !!ts.initial && ts.inTeam() && teamPayload(ts) === undefined;
}

/** Value for PATCH (ppk2ShowTeamBanner) or `undefined` when unchanged / not applicable. */
export function showBannerPayload(ts) {
  if (!bannerVisible(ts)) return undefined;
  return ts.showBanner() === (ts.initial.showBanner !== false) ? undefined : ts.showBanner();
}
function remember(user, ts) {
  // Keep the cached ppk2Team attribute in sync so a reopened modal shows the new banner.
  const attr = user.attribute('ppk2Team');
  if (attr) attr.bannerUrl = ts.bannerUrl;
  ts.initial.bannerUrl = ts.bannerUrl;
}
function url(ts) {
  return app.forum.attribute('apiUrl') + '/ppk2/teams/' + ts.initial.id + '/banner';
}
function upload(ts, user, file) {
  if (!file) return;
  // Same limit as the server (BannerService::MAX_BYTES); avoids sending files PHP would drop.
  if (file.size > 2 * 1024 * 1024) {
    app.alerts.show({
      type: 'error'
    }, app.translator.trans('ppk2-profile.lib.banner.too_large', {
      max: 2
    }));
    return;
  }
  const body = new FormData();
  body.append('banner', file);
  ts.uploading = true;
  m.redraw();
  app.request({
    method: 'POST',
    url: url(ts),
    serialize: raw => raw,
    body
  }).then(response => {
    ts.bannerUrl = response.bannerUrl;
    remember(user, ts);
    app.alerts.show({
      type: 'success'
    }, t('uploaded'));
  }).catch(() => {}) // Flarum shows the server message (wrong type, too large, 403…)
  .finally(() => {
    ts.uploading = false;
    m.redraw();
  });
}
function remove(ts, user) {
  if (!window.confirm(t('remove_confirm'))) return;
  ts.uploading = true;
  app.request({
    method: 'DELETE',
    url: url(ts)
  }).then(() => {
    ts.bannerUrl = null;
    remember(user, ts);
    app.alerts.show({
      type: 'success'
    }, t('removed'));
  }).catch(() => {}).finally(() => {
    ts.uploading = false;
    m.redraw();
  });
}

/** «БАННЕР КОМАНДЫ»: banner (or placeholder), upload for captain / зам, per-player checkbox. */
export function bannerSection(ts, user, loading) {
  if (!bannerVisible(ts)) return [];
  const team = ts.initial;
  const busy = loading || ts.uploading;
  let input;
  return [section(t('section')), m("div", {
    className: "Ppk2Banner"
  }, ts.bannerUrl ? m("img", {
    className: "Ppk2Banner-img",
    src: ts.bannerUrl,
    alt: team.name,
    width: "1200",
    height: "200"
  }) : m("div", {
    className: "Ppk2Banner-placeholder"
  }, m("span", {
    className: "Ppk2Banner-logo"
  }, m(Icon, {
    name: "fas fa-fish"
  })), m("span", {
    className: "Ppk2Banner-text"
  }, m("span", {
    className: "Ppk2Banner-name"
  }, team.name), m("span", {
    className: "Ppk2Banner-sub"
  }, t('placeholder'))))), team.canManageBanner ? m("div", {
    className: "Ppk2BannerActions"
  }, m("input", {
    type: "file",
    accept: "image/png,image/jpeg",
    name: "ppk2Banner",
    style: "display:none",
    oncreate: vnode => input = vnode.dom,
    onupdate: vnode => input = vnode.dom,
    onchange: e => {
      upload(ts, user, e.target.files[0]);
      e.target.value = '';
    }
  }), m(Button, {
    className: "Button",
    icon: "fas fa-upload",
    loading: ts.uploading,
    disabled: busy,
    onclick: () => input && input.click()
  }, t('upload')), ts.bannerUrl ? m(Button, {
    className: "Button Button--link Ppk2BannerRemove",
    icon: "fas fa-trash",
    disabled: busy,
    onclick: () => remove(ts, user)
  }, t('remove')) : null, m("span", {
    className: "Ppk2BannerHint"
  }, t('hint')), m("span", {
    className: "Ppk2BannerTip"
  }, tip(t('upload_tip')))) : m("div", {
    className: "Ppk2BannerActions"
  }, m("span", {
    className: "Ppk2BannerHint"
  }, t('members_hint'))), field('showBanner', t('show_label'), m("label", {
    className: "Ppk2Check"
  }, m("input", {
    type: "checkbox",
    name: "ppk2ShowTeamBanner",
    checked: ts.showBanner(),
    disabled: loading,
    onchange: e => ts.showBanner(e.target.checked)
  }), m("span", null, t('show_checkbox'))), null, t('show_tip'))];
}
flarum.reg.add('ppk2-profile', 'forum/components/BannerSection', { bannerState: bannerState,bannerVisible: bannerVisible,showBannerPayload: showBannerPayload,bannerSection: bannerSection, });